import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../../common/hooks/hooks";
import { selectCurrentStep } from "../checkoutSelectors";
import { setCurrentStep, CheckoutStep } from "../checkoutSlice";

/**
 * Synchronizes the current checkout step with the URL query parameter `?step=...`.
 * - On mount: Reads URL and dispatches step change.
 * - On update: Updates URL when Redux step changes.
 */
export const useSyncCheckoutStepToUrl = () => {
  const dispatch = useAppDispatch();
  const currentStep = useAppSelector(selectCurrentStep);
  const isMounted = useRef(false);

  // 1. Initialize state from URL on first mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const stepParam = params.get("step");

    const validSteps: CheckoutStep[] = ["billing", "middle", "payment"];

    if (stepParam && validSteps.includes(stepParam as CheckoutStep)) {
      dispatch(setCurrentStep(stepParam as CheckoutStep));
    }
    isMounted.current = true;
  }, [dispatch]);

  // 2. Sync Redux state changes to URL
  useEffect(() => {
    if (!isMounted.current) return;

    const url = new URL(window.location.href);

    // Only update if the URL is actually different to avoid history spam
    if (url.searchParams.get("step") !== currentStep) {
      url.searchParams.set("step", currentStep);
      window.history.pushState({}, "", url.toString());
    }
  }, [currentStep]);
};
